export enum ExperimentNames {
  FailTransactionWithError = 'specs.universal-editor-app.FailTransactionWithError',
  FixPagesMenuTabs = 'specs.universal-editor-app.FixPagesMenuTabs',
  GetSiteAssetVersionDynamically = 'specs.universal-editor-app.GetSiteAssetVersionDynamically',
  UsePlatformizedAppDescriptor = 'specs.universal-editor-app.UsePlatformizedAppDescriptor',
}
